export const productShortName = 'Diesel Engines & Generators — Professional Edition';
export const productBrand = 'Diesel Engines & Generators';
export const productEdition = 'Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/f6As4Xegf8bvDXoHJLkQx1/MOCKUP_DIESEL.png';
export const productImageAlt =
  'Diesel Engines & Generators Professional Edition: six volumes covering diesel engine fundamentals, fuel systems and injection, engine support systems, diesel generator sets, maintenance and diagnostics, and operation and load testing, plus five bonus resources';

export const checkoutUrl = 'https://diesel-engines-generators.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how a diesel engine really works',
  'No more guessing about fuel injection, lubrication, cooling and turbocharging',
  'No more uncertainty about alternators, voltage regulation and transfer switches',
  'No more improvising maintenance, diagnostics and load testing',
  'No more stress when an alarm goes off or a generator fails to take the load',
];
